window.addEventListener("DOMContentLoaded", function () {
  setTimeout(AddSize, 1000);
  // setTimeout(allowInput, 3000);
  setTimeout(productCus, 3000);
  setTimeout(Txtinput, 3000);
  setTimeout(Addinfo, 1000);

  
    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
     makeupTheDifferenceQty = getUrlParam('_amount');
  }
  if (makeupTheDifferenceQty != null) {
    $("input[name='quantity']").val(makeupTheDifferenceQty);
  }
    var isTypeurl = window.location.href;//判断是否是详情页
      if(isTypeurl.indexOf('products')!=-1){
      $('#product-add-to-cart').removeAttr('style');
      $('#product-add-to-cart').parent('.product-form__item--submit').removeAttr('style');
        if($('h1.product-single__title').text() !='Make Up The Price Difference'){
         if($('#customized_bigtur').length<1){
           $('#product-add-to-cart').bind({click:function(){
                 alert('Product customization information failed to load, please refresh the page and add to the shopping cart again!');
                return false;
            }});   
         }    
        }   
      }
    if (isTypeurl.indexOf("cart") != -1) {
   if($('.bcpo-cart-item-line-price').find('span').attr('data-eur') !=undefined){
     $('#cart_submit').removeAttr("disabled");
   }     
}


  $(".size-close").click(function () {
    $("#mask,.size-popup-kk").css("display", "none");
  });

  $(".mi-close").click(function () {
    $("#mask-mi,.mi-popup-kk").css("display", "none");
  });

    $('#mask-mi').click(function () {
        $(this).css('display', 'none');
        $('#mi-popup-kk').css('display', 'none');
        document.getElementById("buttom-x").style.display = 'none';//wwh8.4新增
        $("body").css('overflow', '')//wwh8.5新增
        $('.font-popup-kk').css('display', 'none'); // hf 25.4.23
    });

  $(".size-cm").click(function () {
    $(this).addClass("size_checked");
    $("#inTable").addClass("size_hidden");
    $("#cmTable").removeClass("size_hidden");
    $(".size-in").removeClass("size_checked");
  });

  $(".size-in").click(function () {
    $(this).addClass("size_checked");
    $("#cmTable").addClass("size_hidden");
    $("#inTable").removeClass("size_hidden");
    $(".size-cm").removeClass("size_checked");
  });

  $('.mi-close-custom').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
        document.getElementById("buttom-x").style.display = 'none';
        $("body").css('overflow', '')
    }); 

  $("#AccessibleNav #SiteNav .site-nav--has-dropdown").mouseover(function () {
    var _offsetTop = $(this).position().top + 29;
    $(this)
      .find(".site-nav__dropdown")
      .css("top", _offsetTop + "px");
  });
});

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

function AddSize() {
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_default']");
  var modal =
    '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 4px;display:inline-block;"><span class="icon-f-09"></span> Größentabelle</a>';
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(AddSize, 1000);
  } else {
    obj.each(function () {
      $(this).find(".bigtur_div_extend").append(modal);
    });
  }
}

function allowInput() {
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_text']");
  obj.each(function () {
    var inputname = $(this).find("input").attr("name");
    var inputlength = $(this).find("input").attr("maxlength");
    $("input[name='" + inputname + "']").after(
      "<span class='allow_input' style='display:none;'><span></span> Links</span>"
    );
    showLeftInput(inputname, inputlength);
  });
}

//   显示剩余可输入字符数
function showLeftInput(inputname, totalchars) {
  $(".allow_input").nextAll().remove();
  $("input[name='" + inputname + "']").keyup(function () {
    var thischars = this.value.replace(/{.*}/g, "").length;
    $(this).next().show();
    if (thischars > totalchars) {
      var CharsToDel = thischars - totalchars;
      this.value = this.value.substring(0, this.value.length - CharsToDel);
    } else {
      $(this)
        .next()
        .children("span")
        .text(totalchars - thischars);
    }
  });
}

function productCus() {
  var _upload = $("input[name='properties[Upload Logo]']");
  if (_upload.attr("data-price") != null) {
    _upload.attr("accept", "image/png, image/jpeg,image/jpg");
    if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
      $("span[class='bigtur_title']").each(function () {
        var htm = $(this).html();
        var title = $(this).text();
        if (title == "Material:") {
          $(this).next().children().css("margin-left", "15px");
        }

        if (htm.indexOf("Team Logo") > -1 || htm.indexOf("Back Logo") > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
          htm =
            '<font size="-2">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>';
          $(this).append(htm);
        }
      });
    }
  } else {
    setTimeout(productCus, 3000);
  }
}

function getFileName(path) {
  var pos1 = path.lastIndexOf("/");
  var pos2 = path.lastIndexOf("\\");
  if (pos < 0) {
    return path;
  } else {
    return path.substring(pos + 1);
  }
}

function Txtinput() {
  const $titleEl = $("h1.product-single__title");
  // 安全取值，防止null调用indexOf报错
  const _title = $titleEl.html() || "";

  let regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？！…―——_'"^%#@\·~&<>《》$=()+-/*{}[\]]|(^\s*)/g;
  if (_title.includes("Hat")) {
    regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z]/g;
  }

  const $backNumInput = $("input[name='properties[Back Number]']");
  // 判断元素存在，并且data-price不为空
  if ($backNumInput.length && $backNumInput.attr("data-price") != null) {
    const device = ios_or_android();
    // 先解绑所有旧事件，避免多次绑定
    $("input[type='text']").off("keyup input");

    // 合并过滤：同时剔除 | 和非法字符
    const eventType = device === "ios" ? "keyup" : "input";
    $("input[type='text']").on(eventType, function () {
      let val = $(this).val();
      val = val.replace(/\|/g, "").replace(regRule, "");
      $(this).val(val);
    });
  } else {
    // 增加最大重试计数，防止无限递归
    if (!Txtinput.retryCount) Txtinput.retryCount = 0;
    Txtinput.retryCount++;
    if (Txtinput.retryCount < 20) {
      setTimeout(Txtinput, 3000);
    }
  }
}




function Addinfo() {
  var mi = $('input[type=radio][name="properties[Material]"]').parents('.bigtur_buttons').find('.bigtur_div_extend');
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_buttons']");
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(Addinfo, 1000);
  } else {
    mi.append(
      `<div class="scmi_div"><a href="javascript:void(0);" class="scmi" onclick="ClickMi()">CMethodenvergleich</a><a></a></div>`
    );
    mi.css('display', 'block');
  }
}

function ClickMi() {
    document.body.style.overflow = 'hidden';
    //wwh8.4新增
    document.getElementById("buttom-x").style.display = 'block';
    var mi_popup_height = $("#mi-popup-kk").height() + 25;
    var buttomleftvalue = ($('body').width() - $("#buttom-x").width()) > 0 ? ($('body').width() - $("#buttom-x").width()) : ($("#buttom-x").width() - $('body').width())
    $(".buttom-x").css({
        top: mi_popup_height + 'px',
        left: buttomleftvalue / 2 + 'px',
    })
    $("#mask-mi").css("height", $(document).height());
    $("#mask-mi").css("width", $(document).width());
    $("#mask-mi").show();
    var $Popup = $('.mi-popup-kk');
    var leftvalue = ($('body').width() - $Popup.width()) > 0 ? ($('body').width() - $Popup.width()) : ($Popup.width() - $('body').width())

    var topvalue = ($(window).height() - $Popup.height() - 350) >= 0 ? '3' : '4';

    $Popup.css({
        left: leftvalue / 2 + 'px',
        top: topvalue / 2 + "rem",
        display: 'block',
        position: 'fixed'
    });
    //wwh新增
    var _title = $(".product-page--title").html();
    if (_title.indexOf('Baseball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/baseball_219fd43a-4252-4517-9914-0e4c0b99a61e.jpg?v=1659596354");
    }
    if (_title.indexOf('Basketball') != -1) {
        if (_title.indexOf('Shorts') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/shorts.jpg?v=1659596354");
        } else if (_title.indexOf('Suit') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_suit_76acdc09-4ccb-4b27-ac73-7e4a75a2bd7a.jpg?v=1659596354");
        } else {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_da1ff709-2631-4755-9f3f-b3ae91d70c39.jpg?v=1659596354");
        }
    }
    if (_title.indexOf('Football') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/football_fe7e41e8-be36-4412-908f-bdf8a5f71f5e.jpg?v=1659596354");
    }
    if (_title.indexOf('Golf') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/golf.jpg?v=1659596354");
    }
    if (_title.indexOf('Hat') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hats.jpg?v=1659596354");
    }
    if (_title.indexOf('Hockey') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hockey.jpg?v=1659596354");
    }
    if (_title.indexOf('Hoodie') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hoodies.jpg?v=1659596354");
    }
    if (_title.indexOf('Pants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/pant.jpg?v=1659596354");
    }
    if (_title.indexOf('Soccer') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/soccer_b18e2250-daea-4aac-8bc8-dbe7fac31909.jpg?v=1659596354");
    }
    if (_title.indexOf('Jacket') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/JD22101901.jpg?v=1666168588");
    }
    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') < 0) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/t-shirt_96c8c99b-ee96-46b0-a4e2-eb668c723d15.jpg?v=1659596354");
    }

    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0278/0263/2328/files/TZ22082205-01.jpg?v=1665124550");
    }
    if (_title.indexOf('Jogger Sweatpants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/Blank.jpg?v=1667894022");
    }
  if (_title.indexOf('Volleyball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/AZ24072430.jpg?v=1722494930");
    }
}

/*
@功能：判断终端是ios还是安卓
 */
function ios_or_android() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if (isAndroid) {
    return "and";
  } else {
    return "ios";
  }
}

